import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';

export const actionTypes = {
  FINANCE_TYPE_ITEM_ADD: 'FINANCE_TYPE_ITEM_ADD',
  FINANCE_TYPE_ITEM_CLEAR: 'FINANCE_TYPE_ITEM_CLEAR',
  FINANCE_TYPE_ITEM_SET: 'FINANCE_TYPE_ITEM_SET',
  FINANCE_TYPE_ITEM_UPDATE: 'FINANCE_TYPE_ITEM_UPDATE',

  FINANCE_TYPE_PATCH_FAILURE: 'FINANCE_TYPE_PATCH_FAILURE',
  FINANCE_TYPE_PATCH_REQUEST: 'FINANCE_TYPE_PATCH_REQUEST',
  FINANCE_TYPE_PATCH_SUCCESS: 'FINANCE_TYPE_PATCH_SUCCESS',

  FINANCE_TYPES_GET_FAILURE: 'FINANCE_TYPES_GET_FAILURE',
  FINANCE_TYPES_GET_REQUEST: 'FINANCE_TYPES_GET_REQUEST',
  FINANCE_TYPES_GET_SUCCESS: 'FINANCE_TYPES_GET_SUCCESS',

  FINANCE_TYPES_POST_FAILURE: 'FINANCE_TYPES_POST_FAILURE',
  FINANCE_TYPES_POST_REQUEST: 'FINANCE_TYPES_POST_REQUEST',
  FINANCE_TYPES_POST_SUCCESS: 'FINANCE_TYPES_POST_SUCCESS',
};

export const actionCreators = {
  getRequest: () => ({
    type: actionTypes.FINANCE_TYPES_GET_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.FINANCE_TYPES_GET_SUCCESS,
    [ERROR_ACTION]: actionTypes.FINANCE_TYPES_GET_FAILURE,
  }),
  getSuccess: (financeTypes: any) => ({
    type: actionTypes.FINANCE_TYPES_GET_SUCCESS,
    payload: { financeTypes },
  }),
  getFailure: (error: Error) => ({
    type: actionTypes.FINANCE_TYPES_GET_FAILURE,
    error,
  }),

  itemAdd: () => ({
    type: actionTypes.FINANCE_TYPE_ITEM_ADD,
  }),
  itemClear: () => ({
    type: actionTypes.FINANCE_TYPE_ITEM_CLEAR,
  }),
  itemSet: (financeType: any) => ({
    type: actionTypes.FINANCE_TYPE_ITEM_SET,
    payload: { financeType },
  }),
  itemUpdate: (financeType: any) => ({
    type: actionTypes.FINANCE_TYPE_ITEM_UPDATE,
    payload: { financeType },
  }),

  patchRequest: (financeType: any) => ({
    type: actionTypes.FINANCE_TYPE_PATCH_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.FINANCE_TYPE_PATCH_SUCCESS,
    [ERROR_ACTION]: actionTypes.FINANCE_TYPE_PATCH_FAILURE,
    payload: { financeType },
  }),
  patchSuccess: (financeType: any) => ({
    type: actionTypes.FINANCE_TYPE_PATCH_SUCCESS,
    payload: { financeType },
  }),
  patchFailure: (error: Error) => ({
    type: actionTypes.FINANCE_TYPE_PATCH_FAILURE,
    error,
  }),

  postRequest: (financeTypes: Array<any>) => ({
    type: actionTypes.FINANCE_TYPES_POST_REQUEST,
    [WAIT_FOR_ACTION]: actionTypes.FINANCE_TYPES_POST_SUCCESS,
    [ERROR_ACTION]: actionTypes.FINANCE_TYPES_POST_FAILURE,
    payload: { financeTypes },
  }),
  postSuccess: (financeTypes: any) => ({
    type: actionTypes.FINANCE_TYPES_POST_SUCCESS,
    payload: { financeTypes },
  }),
  postFailure: (error: Error) => ({
    type: actionTypes.FINANCE_TYPES_POST_FAILURE,
    error,
  }),
};

export default {
  create: actionCreators,
  type: actionTypes,
};
